
export const Edit = (props : any) => {
    return (
        <svg width={props.width || "24"} height={props.height || "25"} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.658 18.333c.464 0 .842.383.842.853a.848.848 0 0 1-.842.853H13.9a.848.848 0 0 1-.842-.853c0-.47.377-.853.842-.853h4.758zm-3.3-12.711 1.23.976c.503.394.84.914.954 1.46.133.601-.008 1.192-.406 1.702L9.814 19.23c-.336.43-.832.672-1.362.68l-2.918.037a.333.333 0 0 1-.328-.26l-.663-2.876c-.115-.528 0-1.075.336-1.496l5.191-6.718a.26.26 0 0 1 .354-.045l2.184 1.738c.142.116.336.179.54.152a.787.787 0 0 0 .68-.869.875.875 0 0 0-.274-.528L11.432 7.34a.315.315 0 0 1-.053-.438l.822-1.066c.76-.977 2.087-1.067 3.157-.215z" fill="#293359" fillRule="evenodd" opacity=".75"/>
        </svg>
    );
}
